import styled from 'styled-components';

import { Link } from 'react-router-dom';
import { breakpoints, breakpointsMax } from '../../../constants/breakPoints';

import dream from '../../../assets/onboarding/door.jpg'

export const HeaderWrapperSmall = styled.section`
  width: 100%;
  display: flex;
  height: 3.3rem;
  align-items: center;
  background-color: var(--secondary-aqua);
`;

export const HeaderWrapper = styled.div`
  /* padding: 2rem 1.8rem; */
  margin: 12px auto;
  max-width: 600px;
  flex-direction: column;
  flex: 1 1 auto;
  -webkit-flex: 1 1 auto;
  align-items: center;
`;

export const LogoWrapper = styled.div`
  text-align: center;
  margin-bottom: 1rem;
  img {
    margin: auto;
    width: 200px;
  }
`;

export const BackgroundWrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(0deg, var(--primary-navy), var(--secondary-blue), var(--secondary-aqua)) !important; 
`;

export const SignUpBackgroundWrapper = styled.div`
  min-height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-image: url(${dream}), linear-gradient(90deg, #0A2156, #0C999D);

  @media ${breakpointsMax.laptopL} {
    background-image: linear-gradient(90deg, #0A2156, #0C999D);
  }
`

export const Main = styled.main`
  max-width: 100rem;
  margin: 0 auto;
  padding: 2rem 3rem 1rem 250px;

  @media ${breakpointsMax.tablet} {
    padding: 0rem 1rem 1rem 1rem;
  }

  @media ${breakpoints.tablet} {
    padding: 2rem 1rem 1rem 250px;
  }
  section {
    h1 {
      text-align: center;
      margin-bottom: 2rem;
    }
  }
`;

export const Fieldset = styled.fieldset`
  padding: 2rem;
  margin: 0 auto;
  max-width: 1000px;
  flex: 1 1 auto;
  -webkit-flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.02);
  color: #4a4a4a;
  display: block;
  padding: 3.25rem;
  @media ${breakpointsMax.tablet} {
    padding: 2rem;
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  button {
    width: 100%;
  }
`;

export const Input = styled.input`
  border: ${({ error }) =>
    error
      ? 'solid 2px var(--secondary-cherry)'
      : 'solid 2px rgb(225, 225, 225)'};
  font-weight: 400;
  outline: none;
  transition: all ease 0.2s;
  background: none;
  padding: 15px;
  border-width: 2px;
  border-radius: 5px;
  font-size: initial;
  :active,
  :focus {
    font-size: initial;
    border: solid 2px rgb(195, 195, 195);
  }
`;

export const Legend = styled.legend`
  /* hide legend but keep for accessibility */
  position: absolute !important;
  opacity: 0;
  pointer-events: none;
`;

export const Row = styled.div`
  margin-bottom: ${({ marginBottom }) => marginBottom || '0rem'};
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const FlexWrapperTerms = styled.div`
  display: flex;
  align-items: center;
  margin: 45px 0px 5px 0px;
  a {
    margin-left: 0.5rem;
    font-size: 14px;
  }
`;

export const Label = styled.label`
  /* hide label but keep for accessibility */
  position: absolute !important;
  opacity: 0;
  pointer-events: none;
`;

export const Checkbox = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;

export const StyledCheckbox = styled.span`
  position: absolute;
  left: 0px;
  height: 1rem;
  width: 1rem;
  background-color: transparent;
  border-radius: 4px;
  border: 1px solid var(--neutral-mist);
  border: ${({ error }) => error && '1px solid red'};
  cursor: pointer;
  transition: all 0.3s ease-out;
  -webkit-transform: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;

  :after {
    position: absolute;
    content: '';
    left: 0.5rem;
    top: 0.5rem;
    height: 0px;
    width: 0px;
    border-radius: 4px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(0deg) scale(0);
    -ms-transform: rotate(0deg) scale(0);
    transform: rotate(0deg) scale(0);
    opacity: 1;
    -webkit-transform: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    -ms-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
  }
`;

export const CheckboxLabel = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  min-height: 1rem;
  padding-left: 2rem;
  font-weight: 300;
  line-height: 1rem;
  font-size: 14px;
  float: right;
  margin-left: auto;
  margin-right: 0;

  input:checked ~ span {
    background-color: var(--secondary-aqua);
    border-radius: 5px;
    -webkit-transform: rotate(0deg) scale(1);
    -ms-transform: rotate(0deg) scale(1);
    transform: rotate(0deg) scale(1);
    opacity: 1;
  }

  input:checked ~ span::after {
    -webkit-transform: rotate(45deg) scale(1);
    -ms-transform: rotate(45deg) scale(1);
    transform: rotate(45deg) scale(1);
    opacity: 1;
    left: 5px;
    top: 1px;
    width: 4px;
    height: 0.5rem;
    border: solid white;
    border-width: 0 2px 2px 0;
    background-color: transparent;
    border-radius: 0;
  }
`;

export const StyledLink = styled(Link)`
  color: var(--secondary-aqua);
  text-decoration: underline;

  :hover,
  :active,
  :focus {
    color: var(--primary-navy);
  }
`;

export const StyledExtLink = styled.a`
  color: var(--secondary-aqua);
  text-decoration: underline;

  :hover,
  :active,
  :focus {
    color: var(--secondary);
  }
`;

export const LogInWrapper = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 2rem;
  p {
    margin-bottom: 0.5rem;
    font-weight: 300;
    font-size: 14px;
  }
`;

export const ErrorMsg = styled.p`
  color: var(--secondary-cherry);
  font-size: 14px;
  align-self: flex-end;
  padding-top: 0.25rem;
`;

export const SubmitErrorMsg = styled(ErrorMsg)`
  margin-bottom: 1rem;
  align-self: center;
  width: 100%;
  text-align: center;
`;

export const SignInText = styled.div`
  text-align: center;
  margin: 1rem 0rem;
  p {
    display: inline-block;
    position: relative;
    text-align: center;
    span {
      background: #fff;
      padding: 0 10px;
      position: relative;
      z-index: 1;
    }
    &:before {
      background: #ddd;
      content: '';
      height: 1px;
      position: absolute;
      top: 50%;
      width: calc(100% + 200px);
      left: -150px;
    }
  }
  @media ${breakpointsMax.laptop} {
    p {
      &:before {
        height: 0px;
        position: relative;
        top: 0;
        width: 100%;
        left: 0px;
      }
    }
  }
`;

export const SocialLoginWrapper = styled.div`
  justify-content: center;
  .kep-login-facebook {
    font-size: 14px !important;
    padding: 10px !important;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 2px 2px 0px,
      rgba(0, 0, 0, 0.24) 0px 0px 1px 0px;
    border-radius: 2px !important;
    font-family: 'Open Sans' !important;
    font-weight: 400 !important;
    text-align: left;
    text-transform: none;
    height: 41px !important;
    svg {
      margin-right: 22px;
      transform: scale(1.2);
    }
    :hover {
      opacity: 0.9;
    }
  }
  button {
    margin: 5px 0px 5px 0px;
    width: 100%;
  }
`;
